<section class="calls-screen" aria-label="Calls screen">
  <header class="calls-header">
    <div>
      <p class="calls-header__eyebrow">Calls</p>
      <h2>Call Logs</h2>
    </div>
  </header>

  <section class="calls-content" aria-label="Calls content">
    <div class="calls-log-panel">
      <div class="calls-log-toolbar">
        <div class="calls-filter" role="tablist" aria-label="Call log filters">
          <button type="button" mat-button color="primary" [class.active]="activeFilter() === 'all'" (click)="setFilter('all')">
            All
          </button>
          <button type="button" mat-button color="primary" [class.active]="activeFilter() === 'missed'" (click)="setFilter('missed')">
            Missed ({{ missedCount() }})
          </button>
        </div>

        <label class="calls-search" aria-label="Search call logs">
          <span class="material-icons">search</span>
          <input
            type="search"
            placeholder="Search calls"
            [value]="searchTerm()"
            (input)="onSearchInput($event)"
          />
        </label>
      </div>

      <div class="calls-list" aria-label="Call history list">
        @if (filteredLogs().length) {
          @for (entry of filteredLogs(); track entry.id) {
            <article class="call-row">
              <div class="call-row__avatar" [style.--avatar-accent]="entry.accent">
                @if (entry.avatarUrl) {
                  <img [src]="entry.avatarUrl" [alt]="entry.name" />
                } @else {
                  {{ entry.initials }}
                }
              </div>

              <div class="call-row__meta">
                <h3>{{ entry.name }}</h3>
                <p>
                  <span class="material-icons" [class.missed]="entry.status === 'missed' || entry.status === 'declined'">{{ getDirectionIcon(entry.direction, entry.status) }}</span>
                  <span>{{ getDirectionLabel(entry.direction) }}</span>
                  <span class="dot" aria-hidden="true">•</span>
                  <span>{{ getStatusLabel(entry.status) }}</span>
                  <span class="dot" aria-hidden="true">•</span>
                  <span>{{ entry.when }}</span>
                  @if (entry.duration) {
                    <span class="dot" aria-hidden="true">•</span>
                    <span>{{ entry.duration }}</span>
                  }
                </p>
              </div>

              <div class="call-row__actions" aria-label="Call actions">
                <button type="button" mat-icon-button color="primary" aria-label="Start audio call" (click)="onStartCall(entry.channelId, 'audio')">
                  <mat-icon>call</mat-icon>
                </button>
                <button type="button" mat-icon-button color="primary" aria-label="Start video call" (click)="onStartCall(entry.channelId, 'video')">
                  <mat-icon>videocam</mat-icon>
                </button>
              </div>
            </article>
          }
        } @else {
          <p class="calls-empty">No calls found for this filter.</p>
        }
      </div>
    </div>

    <aside class="calls-side-panel" aria-label="Calls summary">
      <section class="summary-card">
        <h3>Recent Activity</h3>
        <p>{{ weeklySummary().total }} calls</p>
        <small>{{ weeklySummary().completed }} completed, {{ weeklySummary().missed }} missed, {{ weeklySummary().declined }} declined</small>
      </section>

      <section class="summary-card">
        <h3>Missed Calls</h3>
        <p>{{ missedCount() }} total</p>
        <small>Use the missed filter to follow up quickly.</small>
      </section>

      <section class="summary-card summary-card--actions">
        <h3>Quick Actions</h3>
        <button type="button" mat-stroked-button color="primary" (click)="setFilter('all')">Show all logs</button>
        <button type="button" mat-stroked-button color="primary" (click)="setFilter('missed')">Review missed</button>
      </section>
    </aside>
  </section>
</section>
